import backend from '@common/backend';

import { gradeFromBE } from './grades';
import { scheduleLessonFromBE } from './scheduleLessons';

const BASE = '/gradebooks';
const TALENTED_SUMMARIES_BASE = '/talentedSummaries';

export const gradeBooksFromBE = ({ schedule_lesson, grades, ...gradeBook }: any) => ({
	...gradeBook,
	schedule_lesson: schedule_lesson ? scheduleLessonFromBE(schedule_lesson) : null,
	grades: grades.map(gradeFromBE),
});

export const getGradeBooks = async (query: any) =>
	backend
		.get(`${BASE}/`, {
			params: query,
		})
		.then((gradebooks) => gradebooks.map(gradeBooksFromBE));

export const getGradeBook = async (id: number, query: any) =>
	backend
		.get(`${BASE}/${id}`, {
			params: query,
		})
		.then(gradeBooksFromBE);

export const saveGradeBook = async (grade_book_id: number, data: any) =>
	backend.put(`${BASE}/${grade_book_id}`, data).then(gradeBooksFromBE);

export const saveGradeBooks = async (data: any) =>
	backend.put(`${BASE}/bulk`, data).then((gradebooks) => gradebooks.map(gradeBooksFromBE));

export const saveAapGrades = async (data: any[]) => backend.post(`${BASE}/aapStore`, data);

export const completeGradeBook = async (id: number) =>
	backend.put(`${BASE}/complete`, {
		id,
	});

export const changeIsPresent = async (data: any) =>
	backend
		.put(`${BASE}/changeIsPresent`, data)
		.then((gradebooks) => gradebooks.map(gradeBooksFromBE));

export const resetProgress = async (id: number) => backend.post(`${BASE}/${id}/resetProgress`, {});

export const getCommentQuestions = async (query: any) =>
	backend.get(`${BASE}/commentQuestions`, {
		params: query,
	});

export const getTalentedAnswer = async (id: number) =>
	backend.get(`${BASE}/${id}/getTalentedAnswer`);

export const regeneratedIAFeedback = async ({ id, comment }: { id: number; comment: string }) =>
	backend.post(`${BASE}/${id}/ai/grading/regenerate`, { comment });

export const getAiFeedback = async (id: number) => backend.get(`${BASE}/${id}/aiFeedback`);

export const saveTalentedAnswer = async (id: number, data: any) =>
	backend.post(`${BASE}/${id}/updateTalentedAnswer`, data);

export const generateTalentedPdf = async (id: number) =>
	backend.post(`${BASE}/${id}/generateTalentedPdf`, {});

export const getTalentedSummaries = async (studentId: number, scheduleProgramId: number) =>
	backend.get(
		`${TALENTED_SUMMARIES_BASE}/find?student_id=${studentId}&schedule_program_id=${scheduleProgramId}`,
	);

export const saveTalentedSummaries = async (id: number, data: any) =>
	backend.put(`${TALENTED_SUMMARIES_BASE}/${id}`, data);

export const generateFinalPdf = async (id: number) =>
	backend.post(`${TALENTED_SUMMARIES_BASE}/${id}/generateFinalPdf`, {});

export const getSummariesAiFeedback = async (studentId: number, scheduleProgramId: number) =>
	backend.get(
		`${TALENTED_SUMMARIES_BASE}/aiFeedback?student_id=${studentId}&schedule_program_id=${scheduleProgramId}`,
	);

export const publishPdf = async (id: number) => backend.put(`/talentedPdf/${id}/publish`, {});
